"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

// Allows passing props to children via a function rather than cloneElement.
// Some libraries use cloneElement to pass through additional props which does
// not work with children functions.
var Children = function Children(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["children"]);
  return children(props);
};

var _default = Children;
exports["default"] = _default;